import Vue from 'vue'
import Vuex from 'vuex'
import PouchDB from 'pouchdb'
import PouchDBAuth from 'pouchdb-authentication'
import PouchDBFind from 'pouchdb-find'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // username: null,
    user: null,
    serverurl: null,
    dbconfig: new PouchDB('config'),
    messages: [],
    currmodel: { '_attachments': {} },
    metadata: {},
    // db: null,
    dbs: {},
    entities: {
      'inspection': 'IFRM',
      'catodico': 'Insp. Catódica'
    }
  },
  mutations: {
    /* SET_USER (state, user) {
      state.username = user
    },
    UNSET_USER (state) {
      state.username = null
    }, */
    SET_USER (state, user) {
      state.user = user
    },
    UNSET_USER (state) {
      state.user = null
    },
    SET_MESSAGES (state, messages) {
      state.messages = messages
    },
    SET_MESSAGE (state, message) {
      var currentdate = new Date()
      var datetime = '[' + currentdate.getDate() + '/' +
                (currentdate.getMonth() + 1) + '/' +
                currentdate.getFullYear() + ' @ ' +
                currentdate.getHours() + ':' +
                currentdate.getMinutes() + ':' +
                currentdate.getSeconds() + '] '
      state.messages.push(datetime + message)
    },
    SET_SERVER (state, serverurl) {
      state.serverurl = serverurl
    },
    SET_CURRMODEL (state, currmodel) {
      state.currmodel = currmodel
    },
    SET_METADATA (state, metadata) {
      state.metadata = metadata
    },
    SET_DB (state, db) {
      state.db = db
    }
  },
  actions: {
    get_db (context, payload) {
      if (!payload) { payload = {} }
      return new Promise((resolve, reject) => {
        var typex = router.currentRoute.params.typex
        var json = router.currentRoute.params.json
        if (payload.typex) { typex = payload.typex }
        if (payload.json) { json = payload.json }
        if (typex === 'server') {
          context.state.dbconfig.get('config').then(function (config) {
            if (context.state.user && context.state.user[json] && context.state.user[json].db) {
              var url = config.server + '/' + context.state.user[json].db
            } else {
              url = config.server + '/' + json
            }
            if (!(config.server.startsWith('http://') ||
              config.server.startsWith('https://'))) {
              context.commit('SET_MESSAGE', 'get_db: Error de configuración de servidor')
              resolve(null)
            }
            if (!(url in context.state.dbs) || !context.state.dbs[url] || context.state.dbs[url]._destroyed) {
              context.state.dbs[url] = new PouchDB(url, {
                skip_setup: true,
                adapter: 'http',
                fetch: (url, opts) => fetch(url, { ...opts, credentials: 'include' })
              })
              // resolve(context.state.dbs[url])
            }
            context.dispatch('check_login', { db: context.state.dbs[url], nologin: payload.nologin }).then(function () {
              resolve(context.state.dbs[url])
            }).catch(function (err) {
              context.commit('SET_MESSAGE', 'get_db: ' + JSON.stringify(err))
              if (typeof err === 'object' && 'message' in err && !err.message) {
                reject(new Error('Error de conexión'))
              } else {
                reject(err)
              }
            })
          }).catch(function (err) {
            // context.dispatch('update_db', {payload: null})
            context.commit('SET_MESSAGE', 'get_db: ' + JSON.stringify(err))
            if (typeof err === 'object' && 'message' in err && !err.message) {
              reject(new Error('Error de conexión'))
            } else {
              reject(err)
            }
          })
        } else {
          if (!(json in context.state.dbs) || !context.state.dbs[json] || context.state.dbs[json]._destroyed) {
            context.state.dbs[json] = new PouchDB(json)
          }
          resolve(context.state.dbs[json])
        }
      })
    },
    update_db (context, payload) {
      context.commit('SET_DB', payload)
    },
    update_metadata (context, payload) {
      context.commit('SET_METADATA', payload)
    },
    update_currmodel (context, payload) {
      context.commit('SET_CURRMODEL', payload)
    },
    update (context, payload) {
      context.state.dbconfig.get('config').then(function (config) {
        for (var prop in payload) {
          if (prop === 'user') {
            context.commit('SET_USER', payload.user)
            config.user = payload.user
          }
          if (prop === 'serverurl') {
            context.commit('SET_SERVER', payload.serverurl)
            config.server = payload.serverurl
          }
        }
        context.state.dbconfig.put(config)
      })
    },
    get_session (context, payload) {
      return new Promise((resolve, reject) => {
        context.dispatch('get_db', payload).then(function (db) {
          context.dispatch('check_login', { db: db }).then(function (session) {
            resolve(session)
          }).catch(function (err) {
            reject(err)
          })
        }).catch(function (err) {
          reject(err)
        })
      })
    },
    check_login (context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.nologin) {
          resolve(true)
        }
        payload.db.getSession(function (err, response) {
          if (err) {
            // network error
            console.log(err)
            reject(err)
          } else if (!response.userCtx.name) {
            // nobody's logged in
            console.log(response)
            context.dispatch('update', { user: null })
            reject(new Error('Debe loguearse al sistema'))
          } else {
            // response.userCtx.name is the current user
            response.user = response.userCtx
            if (response.userCtx.roles.indexOf('_admin') !== -1) {
              Promise.all([
                context.commit('SET_USER', response.userCtx),
                context.dispatch('update', { user: response.userCtx })
              ]).then(function () {
                resolve(response)
              })
            } else {
              payload.db.getUser(response.userCtx.name).then(function (user) {
                Promise.all([
                  context.commit('SET_USER', user),
                  context.dispatch('update', { user: user })
                ]).then(function () {
                  resolve(response)
                })
              }).catch(function (err) {
                console.log(err)
                reject(err)
              })
            }
          }
          resolve(response)
        })
      })
    },
    init (context) {
      PouchDB.plugin(PouchDBAuth)
      PouchDB.plugin(PouchDBFind)
      context.state.dbconfig.get('config').then(function (config) {
        context.commit('SET_USER', config.user)
        context.commit('SET_SERVER', config.server)
        /* if (config.username) {
          context.dispatch('check_login')
        } */
      }).catch(function (err) {
        console.log(err)
        context.state.dbconfig.put({
          _id: 'config',
          user: null,
          // server: 'https://inspecta2.inmac.work:6984'
          server: 'https://db.inmac.work'
        }).then(function () {
          console.log('insertada config inicial')
          context.commit('SET_MESSAGE', 'init: insertada config inicial.')
        })
      })
    },
    login (context, payload) {
      // var db = new PouchDB(context.state.serverurl + '/test')
      console.log('TRy log.......')
      context.dispatch('get_db', { typex: 'server', nologin: true }).then(function (db) {
        db.logIn(payload.user, payload.pass, function (err, response) {
          if (err) {
            if (err.name === 'unauthorized' || err.name === 'forbidden') {
              // name or password incorrect
              context.commit('SET_MESSAGE', 'Login: Usuario o password errado.')
            } else {
              // cosmic rays, a meteor, etc.
              context.commit('SET_MESSAGE', 'Login: Error de conexión.')
            }
            context.dispatch('update', { user: null })
            console.log(err)
            context.commit('SET_MESSAGE', 'Login: ' + JSON.stringify(err))
          } else {
            /* console.log('login')
            console.log(response)
            context.dispatch('update', {session: payload}) */
            console.log('url server', context.state.serverurl)
            console.log('db', db)
            context.commit('SET_MESSAGES', [])
            context.dispatch('check_login', { db: db })
          }
        })
      })
    },
    logout (context) {
      // var db = new PouchDB(context.state.serverurl + '/test')
      context.dispatch('get_db', { typex: 'server' }).then(function (db) {
        db.logOut(function (err, response) {
          if (err) {
            // network error
            console.log(err)
            context.commit('SET_MESSAGE', 'Logout: ' + JSON.stringify(err))
          }
        })
        context.dispatch('update', { user: null })
      })
    },
    clearmessages (context) {
      context.commit('SET_MESSAGES', [])
    },
    setMessage (context, payload) {
      context.commit('SET_MESSAGE', payload)
    }
  }
})
